/* eslint-disable  @typescript-eslint/no-explicit-any */
import type { PipeMiddlewareElement } from '../../middleware-pipe';
import type { MiddlewarePipeDetails } from '../../models/middleware-pipe-details.model';
import type { SearchTab } from '../../../../components/result-page/search-tab/search-tab';
import type { CoseQueryBodyRequest, FilterRequest } from '../../../../models/cose-api/request/query-body-request.model';
import { coseFacetsMapper, mapCharacteristics } from '../../../mappers/cose/cose-facets-mapper';
import mapFacetNames from '../../../../helpers/mapFacetNames';
import { firstValueFrom } from 'rxjs';
import { makeLogger } from '../../../../logger/logger';
import { FacetsService } from '../../../services/facets/facets.service';
import type { PipeMiddlewareNext } from '../../middleware-pipe';

const { debug } = makeLogger({
  pathToCurrentFile:'utils/middleware-pipe/pipes/cose/req-res-cose-facet-query-facet-mapping.ts',
  loggersList: ['debug']
});

export const reqResCoseFacetQueryFacetMapping: PipeMiddlewareElement<MiddlewarePipeDetails, any> = async (
  details: MiddlewarePipeDetails,
  next: PipeMiddlewareNext<any>,
  middlewareDepth: number,
  middlewareArray: Array<PipeMiddlewareElement<MiddlewarePipeDetails, any>>
): Promise<any> => {
    const searchTab: SearchTab = details.context;
    let facetRequestState: FilterRequest[] = await firstValueFrom(searchTab.facetService.facetsRequestState);
    const searchFilters: FilterRequest[] = [];
    if(details.context.horizontalFilterPanel){
      if(details.context.searchFacetsValuesToRemove?.length > 0 && details.context.searchFacetsValuesToRemove !== undefined){
        details.context.filtersChips = details.context.filtersChips.filter(x => {
            const existingFacetToRemove = details.context.searchFacetsValuesToRemove?.find(facet => facet == x.id);
            if(existingFacetToRemove){
              return;
            }
            return x;
        });
      }

      const filtersChips = details.context.filtersChips;
      if(filtersChips?.length > 0){
        facetRequestState = facetRequestState?.filter(facet => {
            const existingChipsets = filtersChips.filter(x => x.id == facet.id);
            if(existingChipsets !== undefined && existingChipsets.length > 0){
              const chipsetValues = existingChipsets.map(x => x.facetValue);
              facet.children = facet.children.filter(facetChildren => chipsetValues.indexOf(facetChildren.value) !== -1);
            }
            else{
              return;
            }

            if(facet.children.length === 0){
              details.context.filtersChips = details.context.filtersChips.filter(x => x.id !== facet.id);
              return;
            };

            return facet;
        });
      }else{
        // @ts-ignore
        searchTab.facetService.setFacets(null);
        // @ts-ignore
        searchTab.facetService.setFacetsState([]);
        // @ts-ignore
        searchTab.facetService.setFacetsRequestState([]);
        facetRequestState = [];
      }
    }

    if(details.context.searchFacetsValues.length > 0){
      details.context.searchFacetsValues.map(filter => {
          const facetId = filter.id ? filter.id : filter.facetName;
          const existingFacet = facetRequestState.find(x => x.id == facetId);
          if(!existingFacet){
            const existingFacetToRemove = details.context.searchFacetsValuesToRemove?.find(x => x == facetId);
            if(!existingFacetToRemove){
              searchFilters.push({
                id: filter.id,
                children: [{
                  value: filter.facetValue,
                  children:[]
                }]
              });
            }
          }else{
            if(existingFacet.children.length === 0){
              existingFacet.children.push({
                value: filter.facetValue,
                children: []
              });
            }
          }

          const existingChip = details.context.filtersChips.find(x => x.id === filter.id);
          if(existingChip){
            existingChip.facetValue = filter.facetValue;
            existingChip.value = filter.facetValue;
          }else{
            const existingFacetToRemove = details.context.searchFacetsValuesToRemove?.find(x => x == facetId);
            if(!existingFacetToRemove){
              filter.value = filter.facetValue;
              details.context.filtersChips.push(filter);
            }
          }
      });
    }

    if(searchFilters.length > 0) {
      facetRequestState = facetRequestState.concat(searchFilters);
    }

    if(facetRequestState.length > 0) {
      (details.middlewareRequest.requestBody as CoseQueryBodyRequest).filters = [...facetRequestState];
    }

    if(details?.additionalData && details?.additionalData?.forcedFilters) {
      let newFacetsState = [...FacetsService.setUnique(facetRequestState)];
      newFacetsState = newFacetsState.concat([...details.additionalData.forcedFilters]);
      const merged = FacetsService.mergeArrayQueries(newFacetsState);
      // @ts-ignore
      searchTab.facetService.setFacetsState(JSON.parse(JSON.stringify(merged)));
      // @ts-ignore
      searchTab.facetService.setFacetsRequestState(JSON.parse(JSON.stringify(merged)));
      (details.middlewareRequest.requestBody as CoseQueryBodyRequest).filters = FacetsService.clearTreeUnique(merged) as FilterRequest[];
    }

    debug('reqResCoseFacetQueryFacetMapping BEFORE',JSON.stringify(details.middlewareRequest.requestBody));

    const response = await next(details);

    let newResponse = {...response};

    if(response?.facetsOptions?.facets) {
      newResponse = { ...response, ...{ facets: coseFacetsMapper(mapCharacteristics(response?.facetsOptions?.facets)) } };
      newResponse['facets'] = mapFacetNames(searchTab, newResponse['facets']);
      const facets = [...newResponse?.facetsOptions?.facets ?? {}];
      //@ts-ignore
      searchTab.facetService.createUpdateChipsStateFromResponseTree(JSON.parse(JSON.stringify(facets)));

      const marketingProductFacet = facets?.find(
        (facet) => facet?.id === 'badgeTypes',
      );
      if (marketingProductFacet) {
        const selectedMarketingProductValues =
        marketingProductFacet?.children?.filter(
          (child) => child?.selected === true,
        );
    
        if (selectedMarketingProductValues) {
          searchTab.parentDataFlux.root.marketingProductBadgesFilters =
          selectedMarketingProductValues?.map((child) => child?.value);
        }
      }
    }

    debug('reqResCoseFacetQueryFacetMapping AFTER',newResponse['facets']);
    details.context.searchFacetsValuesToRemove = [];
    return new Promise(r=>r(newResponse));
};
